import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'

export const companyLogoService = service
  .enhanceEndpoints({ addTagTypes: ['User'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      uploadCompanyLogo: builder.mutation<
        Res['companyLogo'],
        Req['uploadCompanyLogo']
      >({
        invalidatesTags: ['User'],
        query: ({ company_id, logo }) => {
          const formData = new FormData()
          formData.append('logo', logo)
          return {
            body: formData,
            method: 'POST',
            url: `customers/companies/${company_id}/logo`,
          }
        },
      }),
      // END OF ENDPOINTS
    }),
  })

export async function uploadCompanyLogo(
  store: any,
  data: Req['uploadCompanyLogo'],
  options?: Parameters<
    typeof companyLogoService.endpoints.uploadCompanyLogo.initiate
  >[1],
) {
  return store.dispatch(
    companyLogoService.endpoints.uploadCompanyLogo.initiate(data, options),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useUploadCompanyLogoMutation,
  // END OF EXPORTS
} = companyLogoService
